export const RateNames = {
  EvOffPeak: "SO EV Off-Peak",
  EvPeak: "SO EV Peak",
  Standard: "standard",
  Day: "day",
  Night: "night",
} as const
